export default "__VITE_ASSET__7915d606__"